import WeatherandGeolocationAPI from '../../img/WeatherAPI.webp'
import NetflixCloneAPI from '../../img/NetflixCloneWebsite.webp'

import { Link } from 'react-router-dom';


const Landingpage2 = ({ data }) => {

    const Projects = [];
    console.log(data.ImagesData.length);
    // Adds the props on to the Images array
    for (let i = data.ImagesData.length - 1; i < data.ImagesData.length; i--) {
        Projects.push(data.ImagesData[i]);
        console.log(data.ImagesData[i]);
        if ((data.ImagesData.length - 3) === i) {
            break;
        }

    }

    // const Projects = [
    //     { id: 1, img: NetflixCloneAPI, title: 'Netflix Clone Website API ', description: 'Netflix clone API using TMDB API with a trailer search functionality' },
    //     { id: 2, img: WeatherandGeolocationAPI, title: 'Weather & Geolocation API ', description: 'Simple website are utilizing the Weather API with 5 days a head prediction as well as Geolocation API to locate your location and reflect the weather on your screen' },
    // ]

    return (
        <div className="bg-[#EDE8E8] dark:bg-[#272829] px-0 py-10 md:px-10 ">

            <div className='mb-5 md:mb-10 flex justify-center w-full'>
                <h1 className="inline text-center text-2xl md:text-4xl font-semibold border-b border-black dark:border-white px-3 dark:text-white">Recent Projects</h1>
            </div>

            <div className="w-10/12 mx-auto flex flex-col gap-10">

                {Projects.map((project, key) => (

                    <div key={project.id} className="flex flex-col md:flex-row gap-5 md:gap-10 drop-shadow-2xl dark:text-white">
                        <div className='w-full md:w-3/6'>
                            <img data-aos="zoom-in" data-aos-duration="1000" src={project.ProjectImage} alt="Project picture" />
                        </div>

                        <div className='flex flex-col justify-center items-start w-full md:w-3/6 gap-3'>

                            <p className='text-lg md:text-2xl font-medium'>{project.ProjectName}</p>

                            <p className='text-sm md:text-lg font-light'>{project.ProjectDescription}</p>
                        </div>
                    </div>


                ))}

                <div className='flex justify-end w-3/6 ml-auto'>
                    <div className='flex justify-center w-full'>
                        <Link to="/ProjectPage">
                            <button className='text-xs bg-black px-4 py-1 text-white border border-1 border-black  hover:scale-110 duration-200 dark:bg-white dark:border-white dark:text-black md:text-lg md:px-8 md:py-2'>View all my projects</button>
                        </Link>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Landingpage2;